import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Table, Text } from '@dixa/lib-shared-habla';
import { commandGroupAttributes, } from 'utils/commands';
import { KeybindingCommand } from '../command/keybindingCommand';
/**
 * Represents a component for displaying a group of commands and their
 * keybindings.
 */
export const KeybindingGroup = (props) => {
    const { enrichedCommands, group } = props;
    const groupName = commandGroupAttributes[group].label;
    return (_jsxs(FlexBox, Object.assign({ gap: "300", flexDirection: "column" }, { children: [_jsx(Text.Heading, { children: groupName }), _jsx(Table, Object.assign({ hoverable: true }, { children: _jsx(Table.Tbody, { children: enrichedCommands.map((enrichedCommand) => (_jsx(KeybindingCommand, { enrichedCommand: enrichedCommand }, enrichedCommand.command.name))) }) }))] }), group));
};
